import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { StorefrontComponent } from '../../views/storefront/storefront.component';
import { LandingPageComponent } from '../../views/landing-page/landing-page.component';
import { StorefrontService } from '../../services/storefront.service';

@Component({
  selector: 'app-root-router',
  standalone: true,
  imports: [StorefrontComponent, LandingPageComponent],
  // Deliberately NOT OnPush: this is a routing shell, not a leaf. Its children
  // (storefront, landing page) still keep their state in plain fields updated
  // from subscriptions — an OnPush parent would skip the whole subtree and they
  // would stay stuck on their loading skeleton.
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @if (isStorefront) {
      <app-storefront></app-storefront>
    } @else {
      <app-landing-page></app-landing-page>
    }
  `,
})
export class RootRouterComponent {
  isStorefront: boolean;

  constructor(
    public storefrontService: StorefrontService,
    private router: Router,
  ) {
    this.isStorefront = this.storefrontService.isStorefront();

    // If it's the gutscheine subdomain, redirect to shop map
    if (this.storefrontService.isSubdomain('gutscheine')) {
      this.router.navigate(['/in/Berlin']);
    }
  }
}
